import {Text, Typography} from '@yandex-delivery/blocks'
import React from 'react'
import i18n from 'src/shared/i18n'

import {Button} from '../../button'
import {DOWNLOAD_YANGO_APP} from '../../promo'
import {classes} from './YangoPromoButton.styles'

type Props = {
  onClick: JSX.IntrinsicElements['a']['onClick']
}

const YangoPromoButton: React.FC<Props> = ({onClick}) => {
  return (
    <Button
      className={classes.root}
      fullWidth
      href={DOWNLOAD_YANGO_APP}
      onClick={onClick}
      target="_blank"
      variant="action"
    >
      <Text>
        <Typography color="invert" thickness="medium" variant="body2">
          {i18n.print('yango_route_postcard_download_app', 'Скачать Yango')}
        </Typography>
        <Typography color="invert" variant="caption1">
          {i18n.print('route_postcard_download_text')}
        </Typography>
      </Text>
    </Button>
  )
}

export default YangoPromoButton
